import { AutogenLayoutErrorCodeList } from "./autogen/AutogenLayoutErrorCodeList";


export class ErrorCodeList extends AutogenLayoutErrorCodeList {
}
